<template>
    <group-details :groupId="props.groupId">
        <group-historical-invoices :teamId="props.teamId" :groupId="props.groupId" />
    </group-details>
</template>

<script setup>
import GroupHistoricalInvoices from '~/components/settings/billing/GroupHistoricalInvoices.vue';
import GroupDetails from '../form/GroupDetails.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});
</script>
